import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import { customerStatusTitles } from 'src/constants/customer/constants'
import { CustomerStatus } from 'src/constants/customer/enums'
import { semanticColors } from 'src/constants/semanticTokens'

interface Props {
  status: CustomerStatus
}

const CustomerStatusChipComponent = ({ status }: Props) => {
  if (status === CustomerStatus.Active) {
    return (
      <Chip
        text={customerStatusTitles[CustomerStatus.Active]}
        className={{ backgroundColor: semanticColors.feedback.successBg }}
        textClassName={{ color: semanticColors.feedback.successFg }}
      />
    )
  }

  return (
    <Chip
      text={customerStatusTitles[CustomerStatus.Deleted]}
      className={tw`bg-shades-100`}
      textClassName={tw`text-shades-500`}
    />
  )
}

export const CustomerStatusChip = memo(CustomerStatusChipComponent)
